import { render } from "./WidgetPrecisionPicks.vue?vue&type=template&id=58150a06&ts=true"
import script from "./WidgetPrecisionPicks.vue?vue&type=script&lang=ts"
export * from "./WidgetPrecisionPicks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__